module.exports = __webpack_public_path__ + "static/LucasPope4-3698818216c00ce00369a3cecd9a1737.png";